import React, { useContext } from "react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../../footer/Footer";
import Header from "../../header/Header";
import axios from "../../../services/axios";
import "./BlogDetail.css";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { dataContext } from "../../../context/DataContextProvider";

const BlogDetail = () => {
  const { id } = useParams();
  const { allWebParts } = useContext(dataContext);

  const filterAllWebParts = allWebParts?.filter((x) => x.uniqueName === "digikala-link");
  const filetrKeyDigikalaLink = (key) => {
    if (filterAllWebParts) {
      const result = JSON.parse(filterAllWebParts[0]?.specification)?.filter(
        (item) => {
          return item.Key === key;
        }
      );
      return result;
    }
  };
  
  const [blogDetail, setBlogDetail] = useState();
  const navigate = useNavigate();
  const navigateHandler = (path) => {
    navigate(path);
  };
  useEffect(() => {
    var config = {
      method: "get",
      url: `/api/V1/Ui/Article/GetArticleDetailForUi/${id}`,
      headers: {
        SubSystemKey: window.Configs["sub-system-key"],
      },
    };

    axios(config)
      .then(function (response) {
        setBlogDetail(response.data.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [id]);
  return (
    <div className="blog-detail">
      <Header />
      <div className="blog-detail-container">
        <div className="title-container">
          <h4>{blogDetail?.title}</h4>
        </div>
        <div className="img-container">
          <img
            src={`${window.Configs["ui-base-url"]}/Api/V1/ui/Content/Image?entityName=2&imageName=${blogDetail?.image}`}
            alt="Blog1Img.png"
          />
        </div>
        <div
          className="body"
          dir="rtl"
          dangerouslySetInnerHTML={{ __html: blogDetail?.body }}
        ></div>
        <div className="button-container">
          <a href={filetrKeyDigikalaLink("digikala-link")?.map(
                    (item) => item.Value
                  )}>
            <Button className="digikala-btn">
              <img src="/pic/digikala.png" alt="digikala-icon" />
              <span>خرید از دیجی کالا</span>
            </Button>
          </a>
          {/* <Button className="back-btn" onClick={() => navigateHandler("/")}>
            صفحه قبل
          </Button> */}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BlogDetail;
